import * as moment from 'moment';

export const MOMENT_DATE_TIME_FORMAT = 'YYYY.MM.DD. HH:mm';
export const MOMENT_DATE_FORMAT = 'YYYY.MM.DD.';
export const MOMENT_YEAR_MONTH_FORMAT = 'YYYY.MM.';
export const MOMENT_TIME_FORMAT = 'HH:mm';
export const MOMENT_MONTH_FORMAT = 'MMMM';

export function now(): moment.Moment {
  return moment();
}

export function toMoment(isoDateStr: string | undefined): moment.Moment | undefined {
  if (isoDateStr === undefined) {
    return undefined;
  }
  const m = moment(isoDateStr);
  return m.isValid() ? m : undefined;
}

export function toMomentOrThrow(isoDateStr: string): moment.Moment {
  const m = toMoment(isoDateStr);
  if (m === undefined) {
    throw new Error(`Unable to parse date: ${isoDateStr}`);
  }
  return m;
}

export function combineMoments(date: moment.Moment, time: moment.Moment): moment.Moment {
  return moment({
    year: date.year(),
    month: date.month(),
    date: date.date(),
    hour: time.hour(),
    minutes: time.minutes(),
  })
}

export function toApiDateFormat(m: moment.Moment): string {
  throwIfNotMoment(m);
  const utcMoment = m.clone().utc();
  return utcMoment.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}

export function toStartOfDay(m: moment.Moment): moment.Moment {
  return m.clone().startOf('day');
}

export function toEndOfDay(m: moment.Moment): moment.Moment {
  return m.clone().endOf('day');
}

export function toStartOfWeek(m: moment.Moment): moment.Moment {
  return m.clone().startOf("isoWeek").startOf('day');
}

export function toEndOfWeek(m: moment.Moment): moment.Moment {
  return m.clone().endOf("isoWeek").endOf('day');
}

export function toStartOfYear(m: moment.Moment): moment.Moment {
  return m.clone().startOf('year');
}

export function toEndOfYear(m: moment.Moment): moment.Moment {
  return m.clone().endOf('year');
}

export function toIsoDateString(m: moment.Moment): string {
  throwIfNotMoment(m);
  return m.format('YYYY-MM-DD');
}

export function toIsoString(m: moment.Moment): string {
  throwIfNotMoment(m);
  return m.format();
}

function throwIfNotMoment(m: moment.Moment) {
  if (!moment.isMoment(m)) {
    throw new Error(`Illegal argument, moment expected: ${m}`);
  }
}

export function formatDateTime(isoDateStr: string): string {
  return toMomentOrThrow(isoDateStr).format(MOMENT_DATE_TIME_FORMAT);
}

export function formatDateTimeOrNull(isoDateStr?: string): string | null {
  return isoDateStr ? formatDateTime(isoDateStr) : null;
}

export function formatDate(isoDateStr: string): string {
  return toMomentOrThrow(isoDateStr).format(MOMENT_DATE_FORMAT);
}

export function formatDateOrNull(isoDateStr?: string | null): string | null {
  return isoDateStr ? formatDate(isoDateStr) : null;
}

export function formatTime(isoDateStr: string): string {
  return toMomentOrThrow(isoDateStr).format(MOMENT_TIME_FORMAT);
}

export function formatTimeOrNull(isoDateStr?: string): string | null {
  return isoDateStr ? formatTime(isoDateStr) : null;
}

export function areMomentsEqualToDay(first: moment.Moment, second: moment.Moment): boolean {
  return first.isSame(second, 'day');
}



// WEBPACK FOOTER //
// ./src/utils/date-utils.ts